<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="user-surveys">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm8 md5 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="teal darken-2">
                        <v-toolbar-title>Bienvenido(a) {{ userName }} &nbsp;&nbsp;</v-toolbar-title>
                    </v-toolbar>

                    <!-- Container para lista de encuestas: -->
                    <v-container pa-2 grid-list-md>
                        <v-card class="mx-auto" width="500">
                            <v-img
                                class="teal--text text--lighten-3 align-end"
                                :height="imgHeight"
                                src="@/assets/welcome.jpg"
                                gradient="to bottom left, rgba(0,0,0,0), rgba(0,0,0,0.9)"
                            >
                                <v-card-title>Seleccione una encuesta:</v-card-title>
                            </v-img>

                            <v-card-text>
                                <v-list
                                    subheader
                                    dense
                                    :height="listHeight"
                                    max-height="100%"
                                    class="overflow-y-auto"
                                    color="grey lighten-5"
                                >
                                    <v-list-item-group
                                        v-model="selectedSurveyIndex"
                                        color="orange accent-4"
                                    >
                                        <v-list-item
                                            class="my-list-item"
                                            v-for="(survey, i) in userSurveys"
                                            :key="i"
                                            @click="selectSurvey(survey.encuestaID)"
                                        >
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <v-container pa-0 fluid>
                                                        <v-layout row wrap>
                                                            <v-flex
                                                                md2
                                                                xs6
                                                            >{{ survey.nombreEncuesta }}</v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-card-text>
                        </v-card>

                        <v-layout align-center justify-end row fill-height>
                            <v-flex xs12 sm8 class="text-xs-center text-end">
                                <v-btn
                                    color="teal darken-3"
                                    class="text-none"
                                    text
                                    @click="onNext"
                                    :disabled="selectedSurveyIndex === undefined"
                                >OK</v-btn>
                                <v-btn
                                    color="pink darken-1"
                                    class="text-none"
                                    text
                                    @click="onCancel"
                                >Cancelar</v-btn>
                            </v-flex>
                        </v-layout>
                        <!-- Modal para confirmar cancelación: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bCancelDlg" persistent :width="modalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Salir del sistema</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-exit-run</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <v-container>
                                            <v-layout row>
                                                <v-flex x12 class="text-xs-center">
                                                    <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    x12
                                                    class="text-xs-center"
                                                >¿Desea salir del sistema?</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onLogout"
                                        >Salir del sistema</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelLogout"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar canclación *************************** -->
                        <!-- Modal para pedir que se seleccione una encuesta: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgWarning" persistent :width="modalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title">Selección de encuesta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row justify-center>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert-circle</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs11
                                                    class="justify-center text-center"
                                                >Por favor seleccione una encuesta</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bDlgWarning = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se seleccione una encuesta *********************************** -->
                    </v-container>
                    <!-- Termina container para lista de encuestas del usuario -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>

        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'SurveySelection',
    data() {
        return {
            bCancelDlg: false,
            bDlgWarning: false, //Para desplegar un modal indicando que se debe seleccionar una encuesta (esto es redundante, ya que el botón
            //OK se deshabilita cuando selectedSurveyIndex === undefined)
            selectedSurveyIndex: undefined,
            surveyID: 0
        };
    },
    components: {},
    created() {},
    methods: {
        onNext() {
            if (this.surveyID != 0) {
                //console.log('SurveyID = ', this.surveyID);
                this.$store.dispatch('getUserSurvey', this.surveyID);
            } else {
                this.bDlgWarning = true;
            }
        },

        onCancel() {
            this.bCancelDlg = true;
        },

        onLogout() {
            this.bCancelDlg = false;
            this.$store.dispatch('logout');
        },

        cancelLogout() {
            this.bCancelDlg = false;
        },

        selectSurvey(surveyID) {
            this.surveyID = surveyID;
            //console.log('surveyID = ', this.surveyID);
            //console.log('selectedSurveyIndex = ', this.selectedSurveyIndex);
        }
    },
    computed: {
        ...mapGetters(['userSurveys', 'waitCursor', 'userName']),

        imgHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '250px';
            } else {
                height = '300px';
            }
            return height;
        },

        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '70px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '150px';
            } else {
                height = '200px';
            }
            return height;
        },

        modalWidth() {
            var width = '90%';
            if (this.$vuetify.breakpoint.xs) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '55%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '45%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '35%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '25%';
            }
            return width;
        }
    }
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.9);
}
.user-surveys {
    background: url('../assets/alex-kotliarskyi-QBpZGqEMsKg-unsplash.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>